/* tslint:disable */
/* eslint-disable */
export enum ActionValue {
  Required = 'required',
  Enabled = 'enabled',
  Disabled = 'disabled',
}
